/* eslint-disable no-useless-escape */
export const ipv4Url = RegExp(
  [
    '^https?://([a-z0-9\\.\\-_%]+:([a-z0-9\\.\\-_%])+?@)?',
    '((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\\.){3}(25[0-5]|2[0-4',
    '][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])?',
    '(:[0-9]+)?(/[^\\s]*)?$'
  ].join(''),
  'i'
);

export const findCompanyName = () => {
  let name = window.location.hostname.split('.')[0];
  if (
    (window.devSubdomains && window.devSubdomains.indexOf(name) > -1) ||
    ipv4Url.test(window.location.href)
  ) {
    const cn = window.location.search.substr(1).split('cn=')[1];
    name = cn && cn.split('&')[0];
  }
  return name;
};

export const getGoogleTemplate = type => {
  let buttonText = '';
  let className = '';
  if (type === 'signin') {
    buttonText = 'Google';
    className = 'signInWithGoogleButton';
  } else if (type === 'signup') {
    buttonText = 'Sign up with Google';
    className = 'signInWithGoogleButton signUpWithGoogleButton';
  }
  return (
    "<section class='" +
    className +
    " displayFlexRow alignCenter justifyCenter'><svg class='svgIcon pinCenter' width='24' height='24' viewbox='0 0 30 30'><path fill='#ffffff' d='M10.31.82A15.3,15.3,0,0,0,1.63,8.26a14.72,14.72,0,0,0,0,13.47,15.2,15.2,0,0,0,4.16,5,15.37,15.37,0,0,0,5.56,2.75,16.71,16.71,0,0,0,7.83.08,14,14,0,0,0,6.27-3.19,13.58,13.58,0,0,0,3.88-6.22,17.27,17.27,0,0,0,.39-8H15.31V18h8.34a7.05,7.05,0,0,1-3.06,4.64A8.87,8.87,0,0,1,17.22,24a10.3,10.3,0,0,1-3.65,0,9.16,9.16,0,0,1-3.41-1.44,9.29,9.29,0,0,1-3.51-4.6,8.93,8.93,0,0,1,0-5.84A9.34,9.34,0,0,1,8.87,8.55a9.13,9.13,0,0,1,4.58-2.49,9.31,9.31,0,0,1,4.49.18,8.28,8.28,0,0,1,3.3,1.9l2.81-2.76c.49-.49,1-1,1.49-1.48a15,15,0,0,0-4.93-3A15.75,15.75,0,0,0,10.31.82'></path><path fill='#eb4335' d='M10.31.82A15.8,15.8,0,0,1,20.62.91a14.93,14.93,0,0,1,4.93,3c-.48.51-1,1-1.49,1.48L21.24,8.13a8.37,8.37,0,0,0-3.3-1.9A9.23,9.23,0,0,0,6.65,12.09l-5-3.81A15.29,15.29,0,0,1,10.31.82'></path><path fill='#fbbc05' d='M1.64,8.26l5,3.81a8.88,8.88,0,0,0,0,5.84l-5,3.81a14.66,14.66,0,0,1,0-13.47Z'></path><path fill='#4285f4' d='M29.68,12a18.1,18.1,0,0,1-.36,8.13,13.58,13.58,0,0,1-3.88,6.22l-4.86-3.7A7.05,7.05,0,0,0,23.65,18H15.07c0-2,0-4.07,0-6Z'></path><path fill='#34a853' d='M1.63,21.73l5-3.81a9.34,9.34,0,0,0,3.51,4.6A9.22,9.22,0,0,0,13.56,24a10.12,10.12,0,0,0,3.65,0,8.87,8.87,0,0,0,3.37-1.31l4.86,3.7a13.91,13.91,0,0,1-6.27,3.19,16.71,16.71,0,0,1-7.83-.08,15.26,15.26,0,0,1-9.71-7.75'></path></svg>" +
    buttonText +
    '</section>'
  );
};

export const getDarkGoogleTemplate = type => {
  let buttonText = '';
  let className = '';
  if (type === 'signin') {
    buttonText = 'Sign in with Google';
    className = 'signInWithGoogleButton';
  } else if (type === 'signup') {
    buttonText = 'Sign up with Google';
    className = 'signInWithGoogleButton signUpWithGoogleButton';
  }
  return (
    "<section class='" +
    className +
    " displayFlexRow alignCenter justifyCenter'><div class='google-logo'><svg class='svgIcon pinCenter' width='18' height='18' viewbox='0 0 30 30'><path fill='#ffffff' d='M10.31.82A15.3,15.3,0,0,0,1.63,8.26a14.72,14.72,0,0,0,0,13.47,15.2,15.2,0,0,0,4.16,5,15.37,15.37,0,0,0,5.56,2.75,16.71,16.71,0,0,0,7.83.08,14,14,0,0,0,6.27-3.19,13.58,13.58,0,0,0,3.88-6.22,17.27,17.27,0,0,0,.39-8H15.31V18h8.34a7.05,7.05,0,0,1-3.06,4.64A8.87,8.87,0,0,1,17.22,24a10.3,10.3,0,0,1-3.65,0,9.16,9.16,0,0,1-3.41-1.44,9.29,9.29,0,0,1-3.51-4.6,8.93,8.93,0,0,1,0-5.84A9.34,9.34,0,0,1,8.87,8.55a9.13,9.13,0,0,1,4.58-2.49,9.31,9.31,0,0,1,4.49.18,8.28,8.28,0,0,1,3.3,1.9l2.81-2.76c.49-.49,1-1,1.49-1.48a15,15,0,0,0-4.93-3A15.75,15.75,0,0,0,10.31.82'></path><path fill='#eb4335' d='M10.31.82A15.8,15.8,0,0,1,20.62.91a14.93,14.93,0,0,1,4.93,3c-.48.51-1,1-1.49,1.48L21.24,8.13a8.37,8.37,0,0,0-3.3-1.9A9.23,9.23,0,0,0,6.65,12.09l-5-3.81A15.29,15.29,0,0,1,10.31.82'></path><path fill='#fbbc05' d='M1.64,8.26l5,3.81a8.88,8.88,0,0,0,0,5.84l-5,3.81a14.66,14.66,0,0,1,0-13.47Z'></path><path fill='#4285f4' d='M29.68,12a18.1,18.1,0,0,1-.36,8.13,13.58,13.58,0,0,1-3.88,6.22l-4.86-3.7A7.05,7.05,0,0,0,23.65,18H15.07c0-2,0-4.07,0-6Z'></path><path fill='#34a853' d='M1.63,21.73l5-3.81a9.34,9.34,0,0,0,3.51,4.6A9.22,9.22,0,0,0,13.56,24a10.12,10.12,0,0,0,3.65,0,8.87,8.87,0,0,0,3.37-1.31l4.86,3.7a13.91,13.91,0,0,1-6.27,3.19,16.71,16.71,0,0,1-7.83-.08,15.26,15.26,0,0,1-9.71-7.75'></path></svg></div>" +
    "<span class='google-button-text'>" +
    buttonText +
    '</span></section>'
  );
};

export const getSprinklrTemplate = type => {
  let buttonText = '';
  let className = '';
  if (type === 'signin') {
    buttonText = 'Sprinklr login';
    className = 'signInWithSprinklr';
  }
  return (
    "<section class='" +
    className +
    " displayFlexRow alignCenter justifyCenter'>" +
    buttonText +
    '</section>'
  );
};

export const getOktaTemplate = () => {
  const buttonText = 'Okta login';
  const className = 'signInWithOkta';
  return (
    "<section class='" +
    className +
    " displayFlexRow alignCenter justifyCenter'>" +
    buttonText +
    '</section>'
  );
};

export const getSAMLTemplate = text => {
  const buttonText = text || 'SAML login';
  const className = 'signInWithSAML';
  return (
    "<section class='" +
    className +
    " displayFlexRow alignCenter justifyCenter'>" +
    buttonText +
    '</section>'
  );
};

function getCookieHelper(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export const getCookie = name => {
  const x = getCookieHelper(name);
  return x && (x === 'null' ? undefined : decodeURIComponent(x));
};

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validateNumber = number => {
  const phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return number.match(phoneno);
};

export const getQueryParams = queryString =>
  queryString
    .replace('?', '')
    .split('&')
    .reduce((map, keyValueString) => {
      const [key, value] = keyValueString.split('=');
      map[key] = value;
      return map;
    }, {});

export const qs = key => {
  const key1 = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, '\\$&'); // escape RegEx meta chars
  const match = window.location.search.match(new RegExp('[?&]' + key1 + '=([^&]+)(&|$)'));
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};
